import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo e Descrição */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img src="/logo-white.svg" alt={process.env.REACT_APP_COMPANY_NAME || 'Diamond Cars'} className="h-12 w-auto object-contain" />
            </Link>

            <p className="text-gray-400 mb-6 max-w-md leading-relaxed">
              A sua concessionária de confiança. Encontre o carro dos seus sonhos
              com qualidade garantida e excelente atendimento.
            </p>

            {/* Redes Sociais */}
            <div className="flex space-x-3">
              <a
                href="https://www.facebook.com/share/1KJMW3u1JB/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 hover:bg-blue-600 p-3 rounded-lg transition"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/diamond_cars_rg?igsh=MWR6MW9ydnQ2OWxxdQ=="
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 hover:bg-blue-600 p-3 rounded-lg transition"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>

            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-white font-bold mb-6 text-lg">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/viaturas"
                  className="hover:text-blue-400 transition flex items-center space-x-2 group"
                >
                  <span className="w-0 group-hover:w-2 h-0.5 bg-blue-400 transition-all"></span>
                  <span>Carros Disponíveis</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/sobre"
                  className="hover:text-blue-400 transition flex items-center space-x-2 group"
                >
                  <span className="w-0 group-hover:w-2 h-0.5 bg-blue-400 transition-all"></span>
                  <span>Sobre Nós</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/contacto"
                  className="hover:text-blue-400 transition flex items-center space-x-2 group"
                >
                  <span className="w-0 group-hover:w-2 h-0.5 bg-blue-400 transition-all"></span>
                  <span>Contacto</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contactos */}
          <div>
            <h3 className="text-white font-bold mb-6 text-lg">Contactos</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href={`mailto:${process.env.REACT_APP_COMPANY_EMAIL}`}
                  className="flex items-start space-x-3 hover:text-blue-400 transition group"
                >
                  <Mail className="w-5 h-5 mt-0.5 text-blue-400" />
                  <span className="text-sm">
                    {process.env.REACT_APP_COMPANY_EMAIL || 'diamond.cars.rg@gmail.com'}
                  </span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${process.env.REACT_APP_COMPANY_PHONE}`}
                  className="flex items-start space-x-3 hover:text-blue-400 transition group"
                >
                  <Phone className="w-5 h-5 mt-0.5 text-blue-400" />
                  <span className="text-sm">
                    {process.env.REACT_APP_COMPANY_PHONE || '+351 911 504 560'}
                  </span>
                </a>
              </li>
              <li>
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 mt-0.5 text-blue-400" />
                  <span className="text-sm">
                    {process.env.REACT_APP_COMPANY_ADDRESS || 'R. Monsenhor Miguel de Oliveira 1272, 3880-796 Ovar'}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              &copy; {currentYear} {process.env.REACT_APP_COMPANY_NAME || 'Diamond Cars'}.
              Todos os direitos reservados.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacidade" className="text-gray-500 hover:text-blue-400 transition">
                Privacidade
              </Link>
              <Link to="/cookies" className="text-gray-500 hover:text-blue-400 transition">
                Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
